import { useMutation } from '@tanstack/react-query';
import { axiosInstance } from '../../utils';

const getUserPaymentAccount = async (): Promise<any> => {
  const res = await axiosInstance.get(`/api/payout/account-details`);
  return res.data;
};

export const useGetUserPaymentAccountData = () => {
  return useMutation(getUserPaymentAccount);
};
